import FramePage from "./FramePage";

export default FramePage;
